module.exports = __webpack_public_path__ + "static/media/kinkhao_02_thumb_hover.6663c854.png";